(function () {
  var QUESTION_IDS = {
    reason:     '13128c7594fe6603fee599aebccf29cda4521556',
    experience: 'f67674ded0677b502f97bd64b0d568c5f86e86b4',
    angle:      'cf00d8d2a5619ead349e899c8f7a56d4fe3e0e19'
    // state (c322a0c0999a0a68aefd21f3dff44bc2c7f8e2f1) is intentionally not captured
  };

  document.addEventListener('octane.quiz.questionAnswered', function (e) {
    var id    = e.detail.question_id;
    var value = (e.detail.question_value || [])[0] || '';

    if (id === QUESTION_IDS.reason)     localStorage.setItem('trial_reason', value);
    else if (id === QUESTION_IDS.experience) localStorage.setItem('trial_experience', value);
    else if (id === QUESTION_IDS.angle) localStorage.setItem('trial_angle', value);
    else {
      // Log unrecognized IDs so stale Octane configs surface immediately
      console.warn('[octane-quiz] Unrecognized question_id:', id, e.detail.question_title);
    }
  }, false);
})();
